module.exports = __webpack_public_path__ + "static/media/Kissen_30x30.d469590a.png";